import { makeStyles } from "@material-ui/core/styles"

export const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 2),
    textAlign: "center",
    background: "#fff",
    color: "#333",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    width: "90vw",
    marginTop: "2rem",
    padding: "2rem",
  },

  homePageContentContainer: {
    display: "flex",
    alignItems: "flex-start",
  },
  homePageTextContainer: {
    display: "flex",
    flexDirection: "column",
  },
  flex: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  titleOuter: {
    padding: "1rem",
    marginBottom: "1rem",
  },
  img: {
    width: "70%",
    marginBottom: "20px",
    boxShadow: "3px 15px 59px -23px rgba(0,0,0,0.75)",
    borderRadius: "4px",
  },
  homePageImage: {
    width: "50%",
    height: "50%",
    boxShadow: "3px 15px 59px -23px rgba(0,0,0,0.75)",
    borderRadius: "4px",
    marginLeft: "4rem",
    marginTop: "5.75rem",
  },
  blogPageImg: {
    width: "100%",
    height: "80%",
    borderRadius: "4px",
    boxShadow: "3px 15px 59px -23px rgba(0,0,0,0.75)",
    marginBottom: "10px",
  },

  innerBlogImages: {
    width: "100%",
    height: "300px",
  },
  contactContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "80vw",
    padding: "6rem",
  },
  contactInfoContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "50%",
  },
  contactInfoItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: "#3f51b5",
    textDecoration: "none",
  },
  paper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  orderedList: {
    listStyleType: "none",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
  },
  contactInfo: {
    padding: "1rem",
    marginBottom: "1rem",
    display: "flex",
    flexDirection: "column",
  },
  link: {
    color: "#3f51b5",
    textDecoration: "none",
  },
  blogPaper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "75vw",
    padding: "1rem",
    flexDirection: "column",
    marginBottom: "1rem",
    textAlign: "center",
  },
  postPaper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "30rem",
    height: "400px",
    padding: "1rem",
    marginBottom: "1rem",
    textAlign: "center",
    color: "black",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    marginBottom: "30px",
  },
  blogEntryContainer: {
    display: "flex",
    flexDirection: "column",
    width: "60vw",
    padding: "5rem",
  },
  aboutText: {
    width: "70%",
    marginBottom: "4rem",
  },
}))
